module.exports = __webpack_public_path__ + "static/media/NI.b57044db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/NI.svg
// module id = 2227
// module chunks = 7